var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.084 3.5C18.767 3.5 20.5 5.135 20.5 7.665V16.334C20.5 18.864 18.767 20.5 16.084 20.5H7.916C5.233 20.5 3.5 18.864 3.5 16.334V7.665C3.5 5.135 5.233 3.5 7.916 3.5H16.084ZM7.916 22H16.084C19.622 22 22 19.723 22 16.334V7.665C22 4.276 19.622 2 16.084 2H7.916C4.378 2 2 4.276 2 7.665V16.334C2 19.723 4.378 22 7.916 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91394 12.75H16.0859C16.4999 12.75 16.8359 12.414 16.8359 12C16.8359 11.586 16.4999 11.25 16.0859 11.25H7.91394C7.49994 11.25 7.16394 11.586 7.16394 12C7.16394 12.414 7.49994 12.75 7.91394 12.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6779 16.4979C11.8699 16.4979 12.0629 16.4249 12.2089 16.2769C12.5009 15.9829 12.4999 15.5089 12.2069 15.2169L8.97687 11.9999L12.2069 8.78295C12.4999 8.49095 12.5009 8.01695 12.2089 7.72295C11.9169 7.42895 11.4429 7.42895 11.1489 7.72095L7.38487 11.4689C7.24287 11.6089 7.16387 11.8009 7.16387 11.9999C7.16387 12.1989 7.24287 12.3909 7.38487 12.5309L11.1489 16.2789C11.2949 16.4249 11.4869 16.4979 11.6779 16.4979Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftS);
export default __webpack_public_path__ + "static/media/ArrowLeftS.de85793536f97470769f94cf4da1376a.svg";
export { ForwardRef as ReactComponent };